exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{padding:0;margin:0;list-style:none}a,body{color:#464646}a{text-decoration:none}header{position:fixed;width:100%;height:40px;box-sizing:border-box;background:#fff;z-index:999;padding:10px 0;text-align:center;top:0}header h3{display:none}.page_title{height:40px;box-sizing:border-box;margin-top:40px;margin-bottom:10px;padding:0 10px 10px 20px;border-bottom:1px solid #d6d5d5}.container{padding-bottom:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9f30f72","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 30
// module chunks = 0